var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("rect",{"x":"6","width":"2","height":"14","rx":"1","key":0}),React.createElement("path",{"d":"M13.518 6c.266 0 .482.295.482.666v.668c0 .368-.22.666-.482.666H.482C.216 8 0 7.705 0 7.334v-.668C0 6.298.22 6 .482 6","key":1})]));
}

Plus.defaultProps = {"viewBox":"0 0 14 14","width":"14","height":"14"};

module.exports = Plus;

Plus.default = Plus;
